module.exports = __webpack_public_path__ + "static/media/a-3.bd942c35.jpg";